import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';

export const recalculatePickemRanks = async (pickemId: string) => {
  const response = await api.post(apiEndpoints.recalculatePickemRanks(pickemId));
  return response.data;
};

export const useRecalculatePickemRanksMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: recalculatePickemRanks,
    onSuccess: (_, pickemId) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.detail(pickemId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.leaderboard.pickem(pickemId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      toast.success('Ranks recalculated successfully!');
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.error || 'Failed to recalculate ranks');
    },
  });
};
